import { Navigate, Route, Routes } from "react-router-dom";
import GoogleCallback from "./screens/GoogleCallback";
import LoginForm from "./screens/Login";
import RegisterForm from "./screens/Register";
import SelectOrgForm from "./screens/SelectOrg";

import { MoonOutlined, SunOutlined } from "@ant-design/icons";
import { Button } from "antd";
import { useTheme } from "../../hooks";
import styles from "./styles.module.css";

/**
 * The shell every pre-sign-in screen sits in.
 *
 * It used to be a two-column split with a hardcoded blue gradient panel, three
 * rings and a circular seal on one side. Two problems with that: the panel was
 * pure decoration — it never said what the product does — and its blue was
 * fixed while the rest of the panel runs on the organization's own accent, so
 * it belonged to nobody. This is one centred column on a shared canvas whose
 * illustration is the product itself: task cards, a checklist, a chart, a
 * donut. The artwork keeps its middle empty and the form stands in that gap.
 */
const Auth = () => {
  const { isDark, toggle } = useTheme();

  return (
    <main className={`${styles.authShell} ds-auth-canvas`}>
      <header className={styles.topBar}>
        <a className={styles.brandMark} href="/">
          <span className={styles.brandLogo}>
            <img src="/logo.svg" alt="" />
          </span>
          <span className={styles.brandText}>
            <strong>تسکامون</strong>
            <small>مدیریت پروژه، ساده و یکپارچه</small>
          </span>
        </a>

        <Button
          className={styles.themeToggle}
          type="text"
          shape="circle"
          aria-label={isDark ? "فعال‌کردن تم روشن" : "فعال‌کردن تم تیره"}
          icon={isDark ? <SunOutlined /> : <MoonOutlined />}
          onClick={toggle}
        />
      </header>

      <section className={styles.formSide}>
        <Routes>
          <Route path="/register" element={<RegisterForm />} />
          <Route path="/login" element={<LoginForm />} />
          <Route path="/select-org" element={<SelectOrgForm />} />
          {/* بازگشت از گوگل. مسیرش با `GOOGLE_ALLOWED_TARGETS` سرویس یکی است. */}
          <Route path="/google-callback" element={<GoogleCallback />} />
          <Route path="*" element={<Navigate to="/login" replace />} />
        </Routes>
      </section>
    </main>
  );
};

export default Auth;
